
<div class="modal-header modal-xl">
  <h2 class="modal-title" id="exampleModalLabel">{{ 'audioList' | translate }}</h2>
  <button type="button" class="btn" (click)="modalRef.close()">
    <img src="./assets/icon/close.svg" alt="Icona" />
  </button>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>{{ 'audio' | translate }}</th>
          <th></th>
          <th>{{ 'actions' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audio of audios; let i = index">
          <td class="td-middle">#{{ i +1 }}</td>
          <td>
            <div class="audio-player">
                <audio controls id="player_{{audio.id}}">
                    <source src="{{getAudioUrl(audio.audio_path)}}" type="audio/mp3">
                </audio>
              <!--<button type="button" class="btn btn-primary" (click)="playAudio(audio)">
                <img *ngIf="state == 'Pause' || audio.content != actualAudioSubPath" src="../../../assets/icon/play_arrow.svg" alt="Icona" />
                <img *ngIf="state == 'Play' && audio.content == actualAudioSubPath" src="../../../assets/icon/pause.svg" alt="Icona" />
              </button>-->
              <!--<div class="duration">
                <p>{{ audioDurations[audio.content] || '00:00' }}</p>
              </div>
              <img src="./assets/icon/audio-wave.svg" />-->
            </div>
          </td>
          <!--<td class="td-middle">
            <a href="{{getAudioUrl(audio.audio_path)}}" target="_blank" style="text-decoration: none" (click)="downloadMp3(audio.id)">
 &lt;!&ndash;           <a[href]="getAudioUrl(audio.audio_path)" download="audio.mp3">&ndash;&gt;
                <button type="button" class="btn btn-primary">
                  <img src="./assets/icon/download.svg" alt="Icona" />
                  {{ 'download' | translate }}
                </button>
            </a>
          </td>-->
          <td class="td-middle">
            <button type="button" class="btn btn-primary d-flex justify-content-center align-items-center" (click)="deleteAudio(audio.id)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="white"/>
                </svg>
                {{ 'delete' | translate }}
            </button>
          </td>
        </tr>
        <tr *ngIf="audios === null">
          <div>
            {{ 'noAudios' | translate }}
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</div>
